import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/booking/page.tsx");
